module.exports = __webpack_public_path__ + "static/img/swiper4.fdc4ac98.webp";